var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3083 4.58329V7.91663C18.3083 9.35602 17.267 10.5551 15.8894 10.7912C15.6172 10.8378 15.3916 10.6094 15.3916 10.3333V10.2083C15.3916 7.10829 12.8749 4.58329 9.7666 4.58329H9.6416C9.36546 4.58329 9.13711 4.35764 9.18409 4.08553C9.42096 2.7135 10.6196 1.66663 12.0583 1.66663H15.3916C17.0083 1.66663 18.3083 2.97496 18.3083 4.58329Z",
    fill: "url(#paint0_linear_9996_125984)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7666 5.83337H9.1416H5.80827C3.50827 5.83337 1.6416 7.70004 1.6416 10V14.1667C1.6416 16.4667 3.50827 18.3334 5.80827 18.3334H9.97493C12.2749 18.3334 14.1416 16.4667 14.1416 14.1667V10.8334V10.2084C14.1416 7.79171 12.1833 5.83337 9.7666 5.83337Z",
    fill: "url(#paint1_linear_9996_125984)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9996_125984",
    x1: 13.7249,
    y1: 1.66663,
    x2: 13.7249,
    y2: 10.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9996_125984",
    x1: 7.8916,
    y1: 5.83337,
    x2: 7.8916,
    y2: 18.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelActive);
export default __webpack_public_path__ + "static/media/model-active.ac24063552b35c6c4a728fc8bd2eb003.svg";
export { ForwardRef as ReactComponent };